import { BootstrapOptions, Module } from 'owa-bootstrap';
import updateModule from 'owa-app-module/lib/actions/updateModule';
import { setApp } from 'owa-config/lib/bootstrapOptions';
import { updateServiceConfig } from 'owa-service/lib/config';
import initializeWindowTitle from 'owa-shared-bootstrap/lib/initializeWindowTitle';
import { OwaWorkload, setOwaWorkload } from 'owa-workloads';
import getCurrentModule from 'owa-app-module/lib/selectors/getCurrentModule';
import { getBootstrapOptions } from 'owa-app-module';
import { getWindowTitle } from 'owa-bootstrap/lib/initialization/getWindowTitle';
import { getApp } from 'owa-config';

export function updateModuleForVdirChange(appName: string) {
    const newModule = appNameToModuleMap[appName];
    let options: BootstrapOptions | undefined = getBootstrapOptions(newModule);

    if (getCurrentModule() != newModule && getApp().toLowerCase() != appName) {
        setApp(newModule);
        updateServiceConfig({ appName: newModule });
        initializeWindowTitle(() => getWindowTitle(options!.getModuleName));
        setOwaWorkload(options!.workload || OwaWorkload.None);
        updateModule(newModule);
    }
}

const appNameToModuleMap: { [app: string]: Module } = {
    mail: Module.Mail,
    calendar: Module.Calendar,
    people: Module.People,
    files: Module.FilesHub,
};
